<h2 mat-dialog-title translate>search.user.title</h2>
<div class="dialog__content">
  <form [formGroup]="selectNameForm">
    <mat-form-field appearance="outline">
      <mat-label translate>whitelistDialog.input.search</mat-label>
      <input id="searchInputId" matInput formControlName="user" autocomplete="off" />
    </mat-form-field>
    <mat-error *ngIf="showError" translate> select.empty </mat-error>
  </form>
  <button
    id="searchBtnId"
    mat-stroked-button
    class="dialog__search"
    color="accent"
    [disabled]="searchButtonDisabled"
    (click)="onClickSearch()"
  >
    <span>{{ 'whitelistDialog.btnSearch' | translate | uppercase }}</span>
  </button>
</div>
<mat-dialog-content>
  <mat-radio-group class="dialog__list" [(ngModel)]="userSelected" (change)="radioChange($event)">
    <mat-radio-button *ngFor="let user of usersList" [value]="user">
      {{ data.impersonatedUser ? user.userDescription : user.value }}
      {{ data.impersonatedUser && user.usertype === 'CADENA' ? ' - ' + ('search.Cadena' | translate) : '' }}
      {{ data.impersonatedUser && user.usertype === 'AGENTE' ? ' - ' + ('search.establisment' | translate) : '' }}
      {{ data.impersonatedUser && user.usertype === 'PRESCRIPTOR' ? ' - ' + ('search.presciptor' | translate) : '' }}
      {{ data.impersonatedUser && user.usertype === 'VENDEDOR' ? ' - ' + ('search.vendor' | translate) : '' }}
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="end">
  <button id="cancelId" mat-dialog-close mat-stroked-button class="dialog__search" color="accent">
    <span>{{ 'whitelistDialog.btnCancel' | translate | uppercase }}</span>
  </button>
  <button
    id="selectId"
    mat-flat-button
    class="dialog__search"
    color="accent"
    (click)="selectName(userSelected)"
    [disabled]="acceptButtonDisabled"
  >
    <span>{{ 'whitelistDialog.btnSelect' | translate | uppercase }}</span>
  </button>
</mat-dialog-actions>
